import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@trinity/chat-components/query-keys';

export const useInvalidateChartLibraryWidgetsQuery = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (projectId: number | undefined) => {
      if (projectId === undefined) return;
      queryClient
        .invalidateQueries({ queryKey: queryKeys.projects.chartLibraryWidgets({ projectId }) })
        .catch(() => undefined);
    },
    [queryClient]
  );
};
